window.InifECMobileApp.controller("MailIdentifyController", ['$scope', '$timeout', '$rootScope', '$stateParams', '$state', 'UserService', '$InifECGA',
    function($scope, $timeout, $rootScope, $stateParams ,$state , UserService, $InifECGA) {

        var identifyEmail = function() {

            if($scope.token) {

                UserService.identifyEmail($scope.token).then(function(result) {
                    $timeout(function() {
                        $rootScope.$broadcast('OPEN_MAIL_IDENTIFY_MODAL', {});
                        $InifECGA.sendFinishApplyFBPixel();
                    });
                },function(error) {
                    $timeout(function() {
                        $state.go(window.STATES.HOME);
                        $rootScope.$broadcast('OPEN_ERROR_MESSAGE_MODAL', {
                            title: "無法認證您的 Email，請稍候再試"
                        });
                    })
                })
            }
        }

        var init = function() {
            identifyEmail();
        };

        /*==========================
            Events
        ==========================*/

        /*==========================
            Members
        ==========================*/
        $scope.token = $stateParams.token;

        /*==========================
             Methods
        ==========================*/

        /*==========================
            init
        ==========================*/
        init();
    }
]);